const global = {
  pageCount:5,
  pageSize:20
}

export { global }
